/**
 * TODO: REMOVE THIS FILE AFTER BLACK FRIDAY AND CHRISTMAS
 */

import { getObjectValueByKey } from '@js/utilities/getObjectValueByKey';
import formatPrice from '@js/utilities/formatPrice';

const getProductsInPromotion = async (productIds) => {
    const productIdsMapped = productIds.map((id) => `product_ids[]=${id}`).join('&');

    const response = await fetch(
        `/api/promotions/products?category_id=${window.CATEGORY_ID}&${productIdsMapped}`
    );

    const data = await response.json();

    return data;
};

const getProductIds = () =>
    [...document.querySelectorAll('.js-product-item')].map((el) => el.dataset.productId);

// const handleTimrs = (data, container) => {
//     if (!data?.sale_price?.date_end) {
//         return;
//     }

//     const timerElements = [...container.querySelectorAll('.js-blackfriday-timer')];

//     timerElements.forEach((timerElement) => {
//         timerElement.dataset.deadline = `${data.sale_price.date_end}T${data.sale_price.hour_end}`;
//         timerElement.classList.add('js-timer');
//     });
// };

const handleInjectData = (data, container) => {
    const elements = [...container.querySelectorAll('[data-bf-inject]')];

    const injectorTypes = {
        price: (value) => formatPrice(value),
        percent: (value) => Math.floor(value),
    };

    elements.forEach((el) => {
        const key = el.dataset.bfInject;
        const injectorType = el.dataset.bfInjectType;
        const displayIfValueExist = el.dataset.bfDisplayIfValueExist;

        let val = getObjectValueByKey(data, key);

        if (typeof injectorTypes[injectorType] === 'function') {
            val = injectorTypes[injectorType](val);
        }

        if (val) {
            if (displayIfValueExist) {
                const dVal = getObjectValueByKey(data, displayIfValueExist);
                if (Number(dVal) > 0) {
                    el.innerHTML = val;
                } else {
                    el.closest('[data-bf-inject-parent]')?.remove();
                }
            } else {
                el.innerHTML = val;
            }
        } else {
            el.closest('[data-bf-inject-parent]')?.remove();
        }
    });
};

// const handlePromotionTemplates = (productData, productItemTemplate) => {
//     if (productItemTemplate.classList.contains('.js-add-border')) {
//         productItemTemplate.classList.add('border', 'border-black');
//     }

//     const promoTemplateElements = productItemTemplate.querySelectorAll('.js-promo-template');

//     promoTemplateElements.forEach((promoTemplateElement) => {
//         // const promoPlaceholderElement = promoTemplateElement.querySelector(
//         //     '.js-promo-placeholder'
//         // );
//         const promoContentElement = promoTemplateElement.querySelector('.js-promo-content');

//         handleInjectData(productData, promoContentElement);

//         // promoPlaceholderElement.remove();
//         promoContentElement.classList.remove('d-none');
//     });
// };

// const handlePromotionTemplateChanges = (data) => {
//     const productItemElements = [...document.querySelectorAll('.js-product-item')];

//     const productsInPromoIds = Object.keys(data);

//     productItemElements
//         .filter((el) => !productsInPromoIds.includes(el.dataset.productId))
//         .forEach((el) => {
//             const templatesToShowIfNoPromo = [
//                 ...el.querySelectorAll('.js-show-if-promo-doesnt-exist'),
//             ].filter((ell) => !ell.classList.contains('js-is-bf-promo'));
//             const promoTemplateElements = el.querySelectorAll('.js-promo-template');

//             promoTemplateElements.forEach((promoTemplateElement) => {
//                 promoTemplateElement.remove();
//             });

//             templatesToShowIfNoPromo.forEach((templateToHideIfPromoExists) => {
//                 templateToHideIfPromoExists.classList.remove('d-none');
//             });
//         });

//     productsInPromoIds.forEach((productId) => {
//         const productItemTemplate = productItemElements.find(
//             (el) => el.dataset.productId === productId
//         );

//         if (productItemTemplate) {
//             const productData = data[productId];

//             handlePromotionTemplates(productData, productItemTemplate);
//             // handleTimrs(productData, productItemTemplate);
//         }
//     });
// };

const handleNoPromo = () => {
    const elementsToShow = document.querySelectorAll('.js-show-if-promo-doesnt-exist');

    elementsToShow.forEach((el) => {
        el.classList.remove('d-none');
    });
};

const handleProductHasNotPromo = (productData, productItemTemplate) => {
    if (!productItemTemplate) {
        return;
    }

    const elementsToShow = productItemTemplate.querySelectorAll('.js-hide-if-is-promo');
    const elementsToHide = productItemTemplate.querySelectorAll('.js-show-if-is-promo');

    elementsToShow.forEach((el) => {
        el.classList.remove('d-none');
    });

    elementsToHide.forEach((el) => {
        el.classList.add('d-none');
    });

    handleInjectData(productData, productItemTemplate);
};

const handleProductHasPromo = (productData, productItemTemplate) => {
    const elementsToShow = productItemTemplate.querySelectorAll('.js-show-if-is-promo');
    const elementsToHide = productItemTemplate.querySelectorAll('.js-hide-if-is-promo');

    elementsToShow.forEach((el) => {
        el.classList.remove('d-none');
    });

    elementsToHide.forEach((el) => {
        el.classList.add('d-none');
    });

    handleInjectData(productData, productItemTemplate);
};

const handlePromo = (data) => {
    Object.keys(data).forEach((productId) => {
        const productData = data[productId];
        const productItemTemplate = document.querySelector(
            `.js-product-item[data-product-id="${productId}"]`
        );

        const isPromoInProduct = productData.is_product_in_limited || false;

        // console.log({ productData, productItemTemplate });

        if (isPromoInProduct) {
            handleProductHasPromo(productData, productItemTemplate);
        } else {
            handleProductHasNotPromo(productData, productItemTemplate);
        }
    });
};

export const productsListPromotion = async () => {
    if (!window.IS_PROMO_PRODUCT_ITEM) {
        handleNoPromo();
        return;
    }

    const productIds = getProductIds();

    const data = await getProductsInPromotion(productIds);

    // console.log({ data });

    handlePromo(data);

    const timerModule = await import('@js/utilities/countdownTimer');

    timerModule.default();

    // handlePromotionTemplateChanges(data);
};
